/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrCarbonBlackConfig } from './irrCarbonBlackConfig';
import { IrrCrowdStrikeConfig } from './irrCrowdStrikeConfig';


export interface IrrEdrConfig { 
    carbonBlack?: Array<IrrCarbonBlackConfig>;
    crowdStrike?: Array<IrrCrowdStrikeConfig>;
}

